<template>
  <div :class="{'add-background':!building.image,'image-background':building.image}">
        <div v-if="!building.image">
          <div v-if="building.status">
            <span class="info">{{building.value}}</span>
          </div>
        </div>
        <div v-if="!building.image">
          <div  v-if="building.status">
            <span class="info">{{building.status}}</span>
          </div>
        </div>
        <a v-if="building.image" :href="building.image" data-fancybox="">
          <b-img  :src="building.image" fluid alt="Fluid image"></b-img>
           <span class="info">{{building.value}}</span>
        </a>
</div>
</template>

<script>
export default {
  props: {
    building: {
      type: Object,
      required: true,
    },
    // booked_plots: {
    //   type: Array,
    //   required: true
    // },
    // blocked_plots: {
    //   type: Array,
    //   required: true
    // },
  },
//  computed: {
//     booked_flat_details() {
//       return this.booked_plots.length > 0 ? this.booked_plots.map(b => b.key).includes(this.building.key) : ''
//     },
//     blocked_flat_details() {
//       return this.blocked_plots.length > 0 ? this.blocked_plots.map(b => b.key).includes(this.building.key) : ''
//     },
//  }
}
</script>
<style scoped>
.image-background{
  background: #F5821F;
}
.add-background {
  background: transparent;
}
.info{
  color: #ffffff;
}
</style>